'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.json = json;
function json(data) {
    return new Blob([JSON.stringify(data)], { type: 'application/json' });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fetch-json-client/dist/lib/util.js
// module id = 214
// module chunks = 0